import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { BRANDS_QUERY } from '../../queries';

export function useBrandsQuery( options ) {
    return useQuery( BRANDS_QUERY, options );
}

export function useBrandsQueryWithError( options ) {
    const { data: rawData, loading, error, refetch } = useQuery( BRANDS_QUERY, {
        ...options
    } );

    return useMemo ( () => {
        return {
            error,
            loading,
            data: rawData,
            refetch,
        };
    }, [ error, loading, rawData, refetch ] );
}
